import styled from 'styled-components';

const Heading = styled.div`
width:100%;
display:flex;
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
color: #184A61;
margin: ${({ margin }) => margin ? margin : ''};
`;

const PrivacyCheckBox = styled.div`
width:100%;
display:flex;
margin-bottom:8px;
.icon{
  padding:8px;
  display:flex;
  margin-right:16px;
}
.text{
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color:#184A61;
  display:flex;
  align-items:center;
}
.checkmark{
  display:flex;
  margin: auto 0 auto auto;
}
`;

export { Heading, PrivacyCheckBox }
